"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRepositories = exports.selectRepositoryByPath = exports.selectRepositoryByID = exports.selectSharedRepositoriesWithCurrentUser = exports.selectRoles = exports.selectAllRepositories = exports.removeRepository = exports.updateRepository = exports.createRepository = exports.revokePermission = exports.sharePermission = exports.renameRepository = exports.repositoryStorageConfig = exports.repositorySliceConfig = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var firestore_1 = require("firebase/firestore");
var storage_1 = require("firebase/storage");
var lodash_1 = __importStar(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var firebaseApp;
var firestore;
var storage;
var repositorySliceConfig = function (_firebaseApp) {
    firebaseApp = _firebaseApp;
    firestore = (0, firestore_1.getFirestore)(_firebaseApp);
};
exports.repositorySliceConfig = repositorySliceConfig;
var repositoryStorageConfig = function (storageBucketConfig) {
    console.log('repositoryStorageConfig', storageBucketConfig.repository);
    var repositoryStorageBucket = storageBucketConfig.repository;
    // uncomment the line below to testing with emulator
    // storage = getStorage(firebaseApp, repositoryStorageBucket);
    storage = (0, storage_1.getStorage)(firebaseApp, repositoryStorageBucket);
};
exports.repositoryStorageConfig = repositoryStorageConfig;
var updatePath = function (oldPath, newPath, companyId) { return __awaiter(void 0, void 0, void 0, function () {
    var nextText, q, snapshot, repositories, batch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                nextText = oldPath.replace(/.$/, function (c) { return String.fromCharCode(c.charCodeAt(0) + 1); });
                q = (0, firestore_1.query)((0, firestore_1.collection)(firestore, 'companies', companyId, 'repositories'), (0, firestore_1.where)('folderPath', '>=', oldPath), (0, firestore_1.where)('folderPath', '<', nextText));
                return [4 /*yield*/, (0, firestore_1.getDocs)(q)];
            case 1:
                snapshot = _a.sent();
                repositories = [];
                snapshot.forEach(function (doc) {
                    repositories.push(__assign(__assign({}, doc.data()), { id: doc.id }));
                });
                batch = (0, firestore_1.writeBatch)(firestore);
                return [4 /*yield*/, Promise.all(repositories.map(function (repo) { return __awaiter(void 0, void 0, void 0, function () {
                        var newFolderPath;
                        var _a;
                        return __generator(this, function (_b) {
                            newFolderPath = newPath + ((_a = repo.folderPath) === null || _a === void 0 ? void 0 : _a.slice(oldPath.length));
                            batch.update((0, firestore_1.doc)(firestore, 'companies', companyId, 'repositories', repo.id), { folderPath: newFolderPath });
                            return [2 /*return*/];
                        });
                    }); }))];
            case 2:
                _a.sent();
                return [4 /*yield*/, batch.commit()];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.renameRepository = (0, toolkit_1.createAsyncThunk)('repository/renameRepository', function (data, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, meDetails, uid, companyId, repositoryDoc, repositoryData, oldPath, newPath;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    state = getState();
                    meDetails = (_b = state === null || state === void 0 ? void 0 : state.me) === null || _b === void 0 ? void 0 : _b.details;
                    if (meDetails === null)
                        return [2 /*return*/];
                    uid = (_c = meDetails.uid) !== null && _c !== void 0 ? _c : null;
                    if (uid === null)
                        return [2 /*return*/];
                    companyId = (_d = state === null || state === void 0 ? void 0 : state.setting) === null || _d === void 0 ? void 0 : _d.activeWorkspaceID;
                    if (!companyId)
                        return [2 /*return*/];
                    return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(firestore, 'companies', companyId, 'repositories', data.repositoryId))];
                case 1:
                    repositoryDoc = _f.sent();
                    if (!repositoryDoc.exists())
                        return [2 /*return*/];
                    repositoryData = repositoryDoc.data();
                    return [4 /*yield*/, existFolderWithSameName(companyId, (_e = repositoryData.parentID) !== null && _e !== void 0 ? _e : '', data.name)];
                case 2:
                    if (_f.sent())
                        throw new Error('There is already a folder with the same name!');
                    return [4 /*yield*/, (0, firestore_1.updateDoc)((0, firestore_1.doc)(firestore, 'companies', companyId, 'repositories', data.repositoryId), {
                            fileName: data.name,
                            updatedBy: uid,
                            updatedAt: firestore_1.Timestamp.now(),
                        })];
                case 3:
                    _f.sent();
                    if (repositoryData.isFolder) {
                        oldPath = (repositoryData.folderPath && repositoryData.folderPath !== '' ? repositoryData.folderPath + '/' : '') +
                            repositoryData.fileName;
                        newPath = (repositoryData.folderPath && repositoryData.folderPath !== '' ? repositoryData.folderPath + '/' : '') +
                            data.name;
                        updatePath(oldPath, newPath, companyId);
                    }
                    return [2 /*return*/];
            }
        });
    });
});
var uploadFile = function (companyId, file, storageFileName) { return __awaiter(void 0, void 0, void 0, function () {
    var fileUrl, mimeType, storageRef, fileName, ext, baseStorageRef, uploadTask, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fileUrl = '';
                mimeType = '';
                storageRef = '';
                fileName = file.name;
                ext = fileName.slice(fileName.lastIndexOf('.'));
                storageRef = "/".concat(companyId, "/").concat(storageFileName, "/").concat(storageFileName).concat(ext);
                mimeType = file.type.toLowerCase();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                baseStorageRef = (0, storage_1.ref)(storage, storageRef);
                return [4 /*yield*/, (0, storage_1.uploadBytes)(baseStorageRef, file, { contentType: file.type })];
            case 2:
                uploadTask = _a.sent();
                return [4 /*yield*/, (0, storage_1.getDownloadURL)(uploadTask.ref)];
            case 3:
                fileUrl = _a.sent();
                return [3 /*break*/, 5];
            case 4:
                error_1 = _a.sent();
                console.log(error_1);
                throw new Error(error_1.message);
            case 5: return [2 /*return*/, { fileUrl: fileUrl, mimeType: mimeType, storageRef: storageRef, fileName: fileName }];
        }
    });
}); };
var getFolderPath = function (companyId, folderId) { return __awaiter(void 0, void 0, void 0, function () {
    var path, folderDocRef, folder, folderData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                path = '';
                if (!(folderId && folderId !== '')) return [3 /*break*/, 2];
                folderDocRef = (0, firestore_1.doc)(firestore, 'companies', companyId, 'repositories', folderId);
                return [4 /*yield*/, (0, firestore_1.getDoc)(folderDocRef)];
            case 1:
                folder = _a.sent();
                if (folder.exists()) {
                    folderData = folder.data();
                    if (folderData.isFolder)
                        path =
                            (folderData.folderPath && folderData.folderPath !== '' ? folderData.folderPath + '/' : '') +
                                folderData.fileName;
                }
                _a.label = 2;
            case 2: return [2 /*return*/, path];
        }
    });
}); };
var existFolderWithSameName = function (companyId, parentID, fileName) { return __awaiter(void 0, void 0, void 0, function () {
    var q, queryData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                q = (0, firestore_1.query)((0, firestore_1.collection)(firestore, 'companies', companyId, 'repositories'), (0, firestore_1.where)('parentID', '==', parentID), (0, firestore_1.where)('fileName', '==', fileName), (0, firestore_1.where)('isFolder', '==', true));
                return [4 /*yield*/, (0, firestore_1.getDocs)(q)];
            case 1:
                queryData = _a.sent();
                return [2 /*return*/, !queryData.empty];
        }
    });
}); };
var cascadePermissionBatch = function (_a) {
    var repositories = _a.repositories, _repositoryId = _a._repositoryId, _b = _a._batch, _batch = _b === void 0 ? null : _b, companyId = _a.companyId, payload = _a.payload;
    var batch = _batch || (0, firestore_1.writeBatch)(firestore);
    var updatingRepository = repositories.find(function (repository) { return repository.id === _repositoryId; });
    var repositoryDocRef = (0, firestore_1.doc)((0, firestore_1.collection)(firestore, 'companies', companyId, 'repositories'), _repositoryId);
    if (updatingRepository) {
        // If update for a folder
        if (updatingRepository.isFolder) {
            batch.update(repositoryDocRef, payload);
            repositories
                .filter(function (_a) {
                var parentID = _a.parentID;
                return parentID === updatingRepository.id;
            })
                .forEach(function (repository) {
                return cascadePermissionBatch({
                    _batch: batch,
                    repositories: repositories,
                    _repositoryId: repository.id,
                    companyId: companyId,
                    payload: payload,
                });
            });
        }
        else {
            // If only update for normal file
            batch.update(repositoryDocRef, payload);
        }
    }
    return batch;
};
exports.sharePermission = (0, toolkit_1.createAsyncThunk)('repository/sharePermission', function (payload, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var companyId, sharingTeamAndStaff, repositoryID, repositories, staffs, teams, updatePermisionBatch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                companyId = payload.companyId, sharingTeamAndStaff = payload.sharingTeamAndStaff, repositoryID = payload.repositoryID;
                repositories = (0, exports.selectSharedRepositoriesWithCurrentUser)(thunkApi.getState());
                if (!companyId || !repositoryID) {
                    return [2 /*return*/];
                }
                staffs = sharingTeamAndStaff.filter(function (_a) {
                    var type = _a.type;
                    return type === 'user';
                }).map(function (_a) {
                    var id = _a.id;
                    return id;
                });
                teams = sharingTeamAndStaff.filter(function (_a) {
                    var type = _a.type;
                    return type === 'team';
                }).map(function (_a) {
                    var id = _a.id;
                    return id;
                });
                updatePermisionBatch = cascadePermissionBatch({
                    _batch: null,
                    repositories: repositories,
                    _repositoryId: repositoryID,
                    companyId: companyId,
                    payload: {
                        teams: firestore_1.arrayUnion.apply(void 0, teams),
                        staffs: firestore_1.arrayUnion.apply(void 0, staffs),
                    },
                });
                return [4 /*yield*/, updatePermisionBatch.commit()];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
exports.revokePermission = (0, toolkit_1.createAsyncThunk)('repository/revokePermission', function (payload, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var companyId, revokeTeamOrStaff, repositoryID, repositories, updatePermisionBatch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                companyId = payload.companyId, revokeTeamOrStaff = payload.revokeTeamOrStaff, repositoryID = payload.repositoryID;
                if (!companyId || !repositoryID) {
                    return [2 /*return*/];
                }
                repositories = (0, exports.selectSharedRepositoriesWithCurrentUser)(thunkApi.getState());
                updatePermisionBatch = cascadePermissionBatch({
                    _batch: null,
                    repositories: repositories,
                    _repositoryId: repositoryID,
                    companyId: companyId,
                    payload: revokeTeamOrStaff.type === 'team'
                        ? {
                            teams: (0, firestore_1.arrayRemove)(revokeTeamOrStaff.id),
                        }
                        : {
                            staffs: (0, firestore_1.arrayRemove)(revokeTeamOrStaff.id),
                        },
                });
                return [4 /*yield*/, updatePermisionBatch.commit()];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
exports.createRepository = (0, toolkit_1.createAsyncThunk)('repository/createRepository', function (repositoryData, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, meDetails, uid, companyId, files, repositoryInfo, path, batch, repositories, parentFolder, docData;
        var _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    state = getState();
                    meDetails = (_b = state === null || state === void 0 ? void 0 : state.me) === null || _b === void 0 ? void 0 : _b.details;
                    if (meDetails === null)
                        return [2 /*return*/];
                    uid = (_c = meDetails.uid) !== null && _c !== void 0 ? _c : null;
                    if (uid === null)
                        return [2 /*return*/];
                    companyId = (_d = state === null || state === void 0 ? void 0 : state.setting) === null || _d === void 0 ? void 0 : _d.activeWorkspaceID;
                    if (!companyId)
                        return [2 /*return*/];
                    files = repositoryData.files, repositoryInfo = __rest(repositoryData, ["files"]);
                    if (!repositoryInfo.isFolder && !(files === null || files === void 0 ? void 0 : files.length))
                        return [2 /*return*/];
                    return [4 /*yield*/, getFolderPath(companyId, repositoryData.parentID)];
                case 1:
                    path = _g.sent();
                    batch = (0, firestore_1.writeBatch)(firestore);
                    repositories = (0, exports.selectSharedRepositoriesWithCurrentUser)(getState());
                    parentFolder = (repositoryData === null || repositoryData === void 0 ? void 0 : repositoryData.parentID)
                        ? repositories.find(function (repository) { return repository.id === repositoryData.parentID; })
                        : null;
                    if (!!repositoryInfo.isFolder) return [3 /*break*/, 5];
                    if (!(files && files.length)) return [3 /*break*/, 4];
                    return [4 /*yield*/, Promise.all(files.map(function (file) { return __awaiter(void 0, void 0, void 0, function () {
                            var repositoryDocRef, repositoryID, fileMeta, docData;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        repositoryDocRef = (0, firestore_1.doc)((0, firestore_1.collection)(firestore, 'companies', companyId, 'repositories'));
                                        repositoryID = repositoryDocRef.id;
                                        return [4 /*yield*/, uploadFile(companyId, file, repositoryID)];
                                    case 1:
                                        fileMeta = _b.sent();
                                        docData = __assign(__assign(__assign({ fileUrl: fileMeta.fileUrl, displayName: (_a = meDetails.displayName) !== null && _a !== void 0 ? _a : '', mimeType: fileMeta.mimeType, storageRef: fileMeta.storageRef, createdBy: uid, createdAt: firestore_1.Timestamp.now(), updatedBy: uid, updatedAt: firestore_1.Timestamp.now(), thumbnailUrl: '', folderPath: path }, repositoryInfo), (parentFolder
                                            ? {
                                                staffs: parentFolder.staffs,
                                                teams: parentFolder.teams,
                                            }
                                            : {
                                                staffs: [uid],
                                                teams: [],
                                            })), { fileName: fileMeta.fileName });
                                        batch.set(repositoryDocRef, docData);
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 2:
                    _g.sent();
                    return [4 /*yield*/, batch.commit()];
                case 3:
                    _g.sent();
                    _g.label = 4;
                case 4: return [3 /*break*/, 8];
                case 5: return [4 /*yield*/, existFolderWithSameName(companyId, (_e = repositoryInfo.parentID) !== null && _e !== void 0 ? _e : '', repositoryInfo.fileName)];
                case 6:
                    if (_g.sent())
                        throw new Error('There is already a folder with the same name!');
                    docData = __assign(__assign({ displayName: (_f = meDetails.displayName) !== null && _f !== void 0 ? _f : '', createdBy: uid, createdAt: firestore_1.Timestamp.now(), updatedBy: uid, updatedAt: firestore_1.Timestamp.now(), folderPath: path }, repositoryInfo), (parentFolder
                        ? {
                            staffs: parentFolder.staffs,
                            teams: parentFolder.teams,
                        }
                        : {
                            staffs: [uid],
                            teams: [],
                        }));
                    return [4 /*yield*/, (0, firestore_1.addDoc)((0, firestore_1.collection)(firestore, 'companies', companyId, 'repositories'), docData)];
                case 7:
                    _g.sent();
                    _g.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    });
});
exports.updateRepository = (0, toolkit_1.createAsyncThunk)('repository/updateRepository', function (repositoryData, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, uid, companyId, id, updateData, collectionRef, docRef, repository;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    state = getState();
                    uid = (_d = (_c = (_b = state === null || state === void 0 ? void 0 : state.me) === null || _b === void 0 ? void 0 : _b.details) === null || _c === void 0 ? void 0 : _c.uid) !== null && _d !== void 0 ? _d : null;
                    if (uid === null)
                        return [2 /*return*/];
                    companyId = (_e = state === null || state === void 0 ? void 0 : state.setting) === null || _e === void 0 ? void 0 : _e.activeWorkspaceID;
                    if (!companyId)
                        return [2 /*return*/];
                    id = repositoryData.id, updateData = __rest(repositoryData, ["id"]);
                    collectionRef = (0, firestore_1.collection)(firestore, 'companies', companyId, 'repositories');
                    docRef = (0, firestore_1.doc)(collectionRef, id);
                    return [4 /*yield*/, (0, firestore_1.getDoc)(docRef)];
                case 1:
                    repository = _h.sent();
                    if (!repository.exists()) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, firestore_1.updateDoc)(docRef, {
                            fileName: updateData.fileName,
                            staffs: (_f = updateData.staffs) !== null && _f !== void 0 ? _f : [],
                            teams: (_g = updateData.teams) !== null && _g !== void 0 ? _g : [],
                            updatedAt: firestore_1.Timestamp.now(),
                            updatedBy: uid,
                        })];
                case 2:
                    _h.sent();
                    _h.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
});
exports.removeRepository = (0, toolkit_1.createAsyncThunk)('repository/deleteRepository', function (repositoryData) { return __awaiter(void 0, void 0, void 0, function () {
    var id, companyId, collectionRef, docRef, repository, data, path, nextText, q, snapshot, repositories_1, batch_1, storageRefs_1, baseStorageRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                id = repositoryData.id, companyId = repositoryData.companyId;
                collectionRef = (0, firestore_1.collection)(firestore, 'companies', companyId, 'repositories');
                docRef = (0, firestore_1.doc)(collectionRef, id);
                return [4 /*yield*/, (0, firestore_1.getDoc)(docRef)];
            case 1:
                repository = _a.sent();
                if (!repository.exists()) return [3 /*break*/, 8];
                data = repository.data();
                return [4 /*yield*/, (0, firestore_1.deleteDoc)(docRef)];
            case 2:
                _a.sent();
                if (!data.isFolder) return [3 /*break*/, 6];
                path = (!data.folderPath || data.folderPath === '' ? '' : data.folderPath + '/') + data.fileName;
                nextText = path.replace(/.$/, function (c) { return String.fromCharCode(c.charCodeAt(0) + 1); });
                q = (0, firestore_1.query)((0, firestore_1.collection)(firestore, 'companies', companyId, 'repositories'), (0, firestore_1.where)('folderPath', '>=', path), (0, firestore_1.where)('folderPath', '<', nextText));
                return [4 /*yield*/, (0, firestore_1.getDocs)(q)];
            case 3:
                snapshot = _a.sent();
                repositories_1 = [];
                snapshot.forEach(function (doc) {
                    repositories_1.push(__assign(__assign({}, doc.data()), { id: doc.id }));
                });
                batch_1 = (0, firestore_1.writeBatch)(firestore);
                storageRefs_1 = [];
                return [4 /*yield*/, Promise.all(repositories_1.map(function (repo) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (!repo.isFolder) {
                                storageRefs_1.push(repo.storageRef);
                            }
                            batch_1.delete((0, firestore_1.doc)(firestore, 'companies', companyId, 'repositories', repo.id));
                            return [2 /*return*/];
                        });
                    }); }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, batch_1.commit()];
            case 5:
                _a.sent();
                storageRefs_1.forEach(function (storageRef) {
                    var baseStorageRef = (0, storage_1.ref)(storage, storageRef);
                    (0, storage_1.deleteObject)(baseStorageRef);
                });
                return [3 /*break*/, 8];
            case 6:
                baseStorageRef = (0, storage_1.ref)(storage, data.storageRef);
                return [4 /*yield*/, (0, storage_1.deleteObject)(baseStorageRef)];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}); });
var initialState = {
    initialized: false,
    repositories: [],
};
var repositorySlice = (0, toolkit_1.createSlice)({
    name: 'repository',
    initialState: initialState,
    reducers: {
        setRepositories: {
            reducer: function (state, action) {
                if (action.payload) {
                    state.repositories = action.payload;
                    state.initialized = true;
                }
            },
            prepare: function (payload) {
                if (payload) {
                    var repositoryModels = payload.map(function (repository) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
                        var mimeType = (_a = repository.mimeType) !== null && _a !== void 0 ? _a : '';
                        return {
                            id: (_b = repository.id) !== null && _b !== void 0 ? _b : '',
                            fileName: (_c = repository.fileName) !== null && _c !== void 0 ? _c : '',
                            fileUrl: (_d = repository.fileUrl) !== null && _d !== void 0 ? _d : '',
                            displayName: (_e = repository.displayName) !== null && _e !== void 0 ? _e : '',
                            thumbnailUrl: (_f = repository.thumbnailUrl) !== null && _f !== void 0 ? _f : '',
                            mimeType: mimeType,
                            storageRef: (_g = repository.storageRef) !== null && _g !== void 0 ? _g : '',
                            fileType: repository.isFolder
                                ? 'Folder'
                                : mimeType.startsWith('image')
                                    ? 'Image'
                                    : mimeType.endsWith('pdf')
                                        ? 'Pdf'
                                        : 'Video',
                            createdAt: repository.createdAt instanceof firestore_1.Timestamp ? (_j = (_h = repository.createdAt) === null || _h === void 0 ? void 0 : _h.toDate().toISOString()) !== null && _j !== void 0 ? _j : '' : '',
                            updatedAt: repository.updatedAt instanceof firestore_1.Timestamp ? (_l = (_k = repository.updatedAt) === null || _k === void 0 ? void 0 : _k.toDate().toISOString()) !== null && _l !== void 0 ? _l : '' : '',
                            createdBy: (_m = repository.createdBy) !== null && _m !== void 0 ? _m : '',
                            updatedBy: (_o = repository.updatedBy) !== null && _o !== void 0 ? _o : '',
                            staffs: (_p = repository.staffs) !== null && _p !== void 0 ? _p : [],
                            teams: (_q = repository.teams) !== null && _q !== void 0 ? _q : [],
                            folderPath: (_r = repository.folderPath) !== null && _r !== void 0 ? _r : '',
                            parentID: (_s = repository.parentID) !== null && _s !== void 0 ? _s : null,
                            isFolder: (_t = repository.isFolder) !== null && _t !== void 0 ? _t : false,
                        };
                    });
                    return { payload: repositoryModels };
                }
                return { payload: null };
            },
        },
    },
});
// Selectors
var selectAllRepositories = function (state) {
    return lodash_1.default.orderBy(state.repository.repositories, function (repo) { return (0, moment_1.default)(repo.updatedAt).unix(); }, 'desc');
};
exports.selectAllRepositories = selectAllRepositories;
var selectActiveAccount = function (state) { return state.me.account; };
var selectActiveUser = function (state) { return state.me.details; };
var selectInternalAdminIds = function (state) { return state.internalAdmins.internalAdmins; };
var selectAllTeams = function (state) { return state.team.teams; };
var selectRoles = function (state) { var _a; return (_a = state.member) === null || _a === void 0 ? void 0 : _a.roles; };
exports.selectRoles = selectRoles;
exports.selectSharedRepositoriesWithCurrentUser = (0, toolkit_1.createSelector)([exports.selectAllRepositories, selectActiveAccount, selectActiveUser, exports.selectRoles, selectInternalAdminIds, selectAllTeams], function (repositories, activeAccount, activeUser, roles, internalAdminIds, teams) {
    var _a, _b;
    var uid = activeUser === null || activeUser === void 0 ? void 0 : activeUser.uid;
    if (!uid || !activeAccount) {
        return [];
    }
    var teamsIncludeCurrentUser = teams
        .filter(function (_team) { return _team.users.includes(uid); })
        .map(function (_a) {
        var teamId = _a.teamId;
        return teamId;
    });
    var role = (_b = (_a = roles === null || roles === void 0 ? void 0 : roles.find(function (u) { return u.userId === (activeUser === null || activeUser === void 0 ? void 0 : activeUser.uid); })) === null || _a === void 0 ? void 0 : _a.role) !== null && _b !== void 0 ? _b : null;
    var isInternalAdmins = !!(uid && (internalAdminIds === null || internalAdminIds === void 0 ? void 0 : internalAdminIds.users.includes(uid)));
    return repositories.filter(function (repository) {
        var _a;
        // Admins have access to all uploaded items via the web app. Sharing of item grants member access on the mobile app.
        if (role === 'admin' || isInternalAdmins) {
            return true;
        }
        // Repository shared for all staffs
        if (repository.staffs.includes('*')) {
            return true;
        }
        var isRepositorySharedWithCurrentUser = repository.staffs.includes(uid);
        var isRepositorySharedWithTeamOfCurrentUser = (_a = (0, lodash_1.intersection)(repository.teams, teamsIncludeCurrentUser)) === null || _a === void 0 ? void 0 : _a.length;
        if (isRepositorySharedWithCurrentUser || isRepositorySharedWithTeamOfCurrentUser) {
            return true;
        }
        return false;
    });
});
exports.selectRepositoryByID = (0, toolkit_1.createSelector)(exports.selectAllRepositories, function (repos) {
    return function callbackFunction(repoId) {
        return repos.find(function (repo) { return repo.id === repoId; }) || null;
    };
});
exports.selectRepositoryByPath = (0, toolkit_1.createSelector)(exports.selectAllRepositories, function (repos) {
    return function callbackFunction(path) {
        var paths = path === null || path === void 0 ? void 0 : path.split('/');
        if (!paths || paths.length < 1)
            return null;
        var fileName = paths[paths.length - 1];
        var filePath = paths.slice(0, paths.length - 1).join('/');
        return repos.find(function (repo) { return repo.folderPath === filePath && repo.fileName === fileName; }) || null;
    };
});
// Actions
exports.setRepositories = repositorySlice.actions.setRepositories;
exports.default = repositorySlice.reducer;
